// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"8cc27c18","456":"cd9d33b9","604":"64f23f06","700":"40bffdf4","704":"8eda7b84","737":"891e1de9","787":"0ea16dec","926":"708d3e4a"}[chunkId] + ".chunk.js";
};